<template>

    <div>
        <b-col lg="3" @click="toggleSelected">
            <div class="layout" :class="{ active: selectedCalss }">
                

                <div class="loader" v-if="loading"></div>
                <b-img-lazy :src="imgpath" width="200px"  alt=""></b-img-lazy>
            </div>
            
        </b-col>
        <p class="layout_p">Layout {{ this.number }}</p>
    </div>

</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-layout-template",
    components: {
        Modal,
        BaseAlert,
    },
    props: {
        image: '',
        number: '',
        
    },
    data() {
        return {
            loading: false,
            selected: false,
        };
    },
    methods: {
        toggleSelected(){
            if(this.selected){
                this.deselect();
            }
            else{
                this.select();
            }
        },
        select(){
            this.selected = true;
            //console.log(this.number);
            this.$emit("layoutselected", this.number);
        },
        deselect(){
            this.selected = false;
            //console.log(this.number);
            this.$emit("layoutdeselected", this.number);
        },
    },
    computed: {
        selectedCalss(){
            if(this.selected){
                return "selected";
            }
            else{
                return "";
            }
        },
        imgpath(){
            return "img/custom/layouts/"+this.number+".png"
        },
        ...mapGetters({ currentAccount: 'currentAccount' }),
    },
    mounted() {
        console.log(this.image);
    },

};
</script>
<style scoped>

.active
{
    background-color: darkgray;
    border: 10 px solid black;
}

.layout
{
    width: 230px;
    padding: 15px;
    margin: 15px;
    /*
    background-color: blue;
    border: 10 px solid black;
    */
}

.layout_p
{
    font-weight: bold;
    text-align: center;
}
</style>